import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";
import TopRankUniCard from "@modules/study/common/top_rank_uni_card";
import styles from "./study_top_rank_two.module.scss";
import { useRouter } from "next/router";

export const StudyOverviewTopRankTwo = ({
  backgroundColor,
  padding,
  heading,
  subHeading,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const router = useRouter();
  const { query } = router;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/university-ranking/top-ranking?countrySlug=${query?.country_name}&limit=8`
        );
        setLoading(false);
        if (res.data) {
          setData(res?.data?.dataResult);
        }
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, [query?.country_name]);

  const LoadingComponent = () => (
    <>
      <Skeleton
        variant="rectangular"
        width={"40%"}
        height={20}
        sx={{ margin: "20px auto" }}
      />
      <Skeleton
        variant="rectangular"
        width={"60%"}
        height={40}
        sx={{ margin: "20px auto" }}
      />
      <Grid container spacing={2} alignItems={"center"}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((_, i) => {
          return (
            <Grid item xs={12} sm={12} md={4} lg={3} key={i}>
              <Skeleton variant="rectangular" width="100%" height={300} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );

  return (
    <Fragment>
      {data?.length > 0 ? (
        <section
          className={styles.section_top_rank}
          style={{ backgroundColor: backgroundColor, padding: padding }}
        >
          <div className={styles.wrapper}>
            {loading ? (
              <LoadingComponent />
            ) : (
              <>
                <div className={styles.title_wrapper}>
                  {heading && <h2 className={styles.title}>{heading}</h2>}
                  {subHeading && <p>{subHeading}</p>}
                </div>
                <div
                  className={`top-rank-slider-wrapper ${styles.top_rank_card_wrapper}`}
                >
                  <Grid
                    container
                    spacing={{ xs: 2, sm: 3, md: 4 }}
                    justifyContent="center"
                  >
                    {data?.map((item, i) => {
                      return (
                        <Grid item lg={3} md={4} sm={6} xs={12} key={i}>
                          <TopRankUniCard key={i} data={item} />
                        </Grid>
                      );
                    })}
                  </Grid>
                </div>
              </>
            )}
          </div>
        </section>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default StudyOverviewTopRankTwo;
